import React from "react";

const HashtagIcon = ({ style, color }: { color?: string; style?: React.CSSProperties }) => {
  let c = "#1062D0";
  if (color) c = color;
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.78953 0.0115383C5.1514 0.0793916 5.3898 0.427758 5.32193 0.789645L4.96993 2.66679H8.28007L8.67807 0.543925C8.74593 0.182045 9.09433 -0.056315 9.4562 0.0115383C9.81807 0.0793916 10.0565 0.427758 9.9886 0.789645L9.6366 2.66679H11.3333C11.7015 2.66679 12 2.96527 12 3.33345C12 3.70164 11.7015 4.00012 11.3333 4.00012H9.3866L8.6366 8.00013H10.6667C11.0349 8.00013 11.3333 8.2986 11.3333 8.6668C11.3333 9.035 11.0349 9.33347 10.6667 9.33347H8.3866L7.9886 11.4563C7.92073 11.8182 7.57233 12.0565 7.21047 11.9887C6.8486 11.9209 6.6102 11.5725 6.67807 11.2106L7.03007 9.33347H3.71995L3.32191 11.4563C3.25406 11.8182 2.90569 12.0565 2.54381 11.9887C2.18193 11.9209 1.94357 11.5725 2.01142 11.2106L2.36338 9.33347H0.666667C0.29848 9.33347 0 9.035 0 8.6668C0 8.2986 0.29848 8.00013 0.666667 8.00013H2.61338L3.36338 4.00012H1.33333C0.965147 4.00012 0.666667 3.70164 0.666667 3.33345C0.666667 2.96527 0.965147 2.66679 1.33333 2.66679H3.61338L4.01142 0.543925C4.07927 0.182045 4.42764 -0.056315 4.78953 0.0115383V0.0115383ZM4.71993 4.00012L3.96995 8.00013H7.28007L8.03007 4.00012H4.71993Z"
        fill={c}
      />
    </svg>
  );
};

export default HashtagIcon;
